import {airBlue} from '@modifi/colors'
import styled from 'styled-components'
import {P} from '@modifi/ui'

export const Anchor = styled.a`
  color: ${airBlue};
  text-decoration: none;
`

export const Img = styled.img``

export const StyledP = styled(P)`
  min-height: 1px;
`

export const Wrapper = styled.div`
  padding-bottom: 64px;
`
